/* eslint-disable */

import * as THREE from 'three'
import Pass from './Pass.js'

const ClearMaskPass = function () {

	Pass.call( this );

	this.needsSwap = false;

};

ClearMaskPass.prototype = Object.create( Pass.prototype );

Object.assign( ClearMaskPass.prototype, {

	render: function ( renderer, writeBuffer, readBuffer, delta, maskActive ) {

		renderer.state.buffers.stencil.setTest( false );

	}

} );

export default ClearMaskPass;


// WEBPACK FOOTER //
// ./src/scripts/libs/experience/EffectComposer/ClearMaskPass.js